<template>
  <Widget>
    <v-card
      class="pl-8 pr-8 pt-8 pb-8"
      style="border-radius: 6px; height: 150px"
      flat
    >
      <v-row justify="center" no-gutters>
        <v-col cols="3">
          <div
            class="mt-4"
            style="
              background-color: var(--red-orange);
              height: 55px;
              width: 55px;
              border-radius: 10px;
              text-align: center;
            "
          >
            <span
              class="Appkit4-icon icon-audience-outline mt-4"
              style="font-size: 20pt; color: white; width: 100%; height: 100%"
            ></span>
          </div>
        </v-col>

        <v-col class="text-center" cols="9">
          <div class="ml-5">
            <div class="appkit-data mb-2">
              {{ statsStore.stats.businessPartnerAnswerStats.noBusinessPartners }}
            </div>
            <p>Business Partners</p>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </Widget>
</template>

<script setup lang="ts">
import Widget from "@/views/dashboard-view/Widget.vue";
import { useStatsStore } from "@/stores/statsStore";
const statsStore = useStatsStore();
</script>
